import { createPortal } from 'react-dom';
import usePortal from 'hooks/usePortal';

const Portal = ({ id, visible, children }) => {
  const target = usePortal(id, visible);

  if (!target) {
    return null;
  }

  return createPortal(children, target);
};

export default Portal;
